module.exports = __webpack_public_path__ + "static/img/suspension_cn.2a778096.png";